import React, { JSX } from 'react';
import type {
  BasePatcherProps,
  WithPassedPatchableGroupProps
} from './PatchableGroup';

export type CustomPatcherProps<T> = BasePatcherProps & {
  componentProps?: any;
  render: (
    props: WithPassedPatchableGroupProps<
      T,
      { error?: string; loading?: boolean; doPatch: (v: any) => void }
    >
  ) => JSX.Element;
};

const CustomPatcherComponent = <T,>({
  name,
  error,
  // wrapper,
  patchable,
  loading,
  // hideLoadingOverlay,
  // sourceType,
  render,
  componentProps
}: WithPassedPatchableGroupProps<T, CustomPatcherProps<T>>) => {
  if (!patchable && name) {
    throw new Error(
      'A Patcher component may be used as a child of a PatchableGroup'
    );
  }

  const doPatch = (v: string) => {
    if (patchable) {
      const { onPatch } = patchable;
      onPatch({ [name]: v });
    }
  };

  return render({
    error,
    loading,
    patchable,
    doPatch,
    ...componentProps
  });
};

export const CustomPatcher = <T,>(props: CustomPatcherProps<T>) => (
  <CustomPatcherComponent {...props} />
);
